import React, { useMemo, useCallback } from 'react'

import AnnotationOverlay from '../AnnotationOverlay'

import { useAnnotationOverlayOrigin } from '../../hooks'

interface ArtboardAnnotationOverlayProps {
  shareIdentifier: string
  permanentArtboardId: string
  artboardWidth: number
  artboardHeight: number
}

const ArtboardAnnotationOverlay = (props: ArtboardAnnotationOverlayProps) => {
  const {
    shareIdentifier,
    permanentArtboardId,
    artboardWidth,
    artboardHeight,
  } = props

  const [{ origin, scale }] = useAnnotationOverlayOrigin()

  const referenceBounds = useMemo(
    () => ({
      x: 0,
      y: 0,
      height: artboardHeight,
      width: artboardWidth,
    }),
    [artboardHeight, artboardWidth]
  )

  const getArtboardBounds = useCallback(
    () => ({
      height: artboardHeight,
      width: artboardWidth,
    }),
    [artboardHeight, artboardWidth]
  )

  const getArtboardContainerBounds = useCallback(() => {
    const topOffset = origin?.current?.getBoundingClientRect().top || 0
    const leftOffset = origin?.current?.getBoundingClientRect().left || 0
    const scaledWidth = artboardWidth * (scale?.current || 1)
    const scaledHeight = artboardHeight * (scale?.current || 1)

    return {
      top: topOffset,
      right: scaledWidth + leftOffset,
      bottom: scaledHeight + topOffset,
      left: leftOffset,
    }
  }, [artboardHeight, artboardWidth, origin, scale])

  return (
    <AnnotationOverlay
      shareIdentifier={shareIdentifier}
      permanentArtboardId={permanentArtboardId}
      referenceBounds={referenceBounds}
      getArtboardBounds={getArtboardBounds}
      getArtboardContainerBounds={getArtboardContainerBounds}
    />
  )
}

export default ArtboardAnnotationOverlay
